import React, { useState } from "react";
import { Col, Row, Card, Form, Button, ToastContainer } from "react-bootstrap";
import Select from "react-select";
import { XCircleIcon } from "@heroicons/react/outline";
import "react-phone-input-2/lib/style.css";
import { Toast } from "react-bootstrap";

import { OverlayTrigger, Tooltip } from "react-bootstrap";
import { ChatFlowApiTables } from "components/Tables";
import { IoMdAddCircle } from "react-icons/io";
import { useSaveAPIsMutation, useTestAPIMutation } from "Services/services";

export default () => {
  const [showToast, setShowToast] = useState(false);
  const [toastMessage, setToastMessage] = useState("");
  const [toastVariant, setToastVariant] = useState("success");

  const [apiName, setApiName] = useState("");
  const [apiUrl, setApiUrl] = useState("");
  const methodOptions = [
    { value: "GET", label: "GET" },
    { value: "POST", label: "POST" },
    { value: "PUT", label: "PUT" },
    { value: "PATCH", label: "PATCH" },
    { value: "DELETE", label: "DELETE" },
  ];
  const [apiMethod, setApiMethod] = useState(null);
  const [parameterType, setParameterType] = useState(null);
  const [parameters, setParameters] = useState([]);
  const [objectParameters, setObjectParameters] = useState("");
  const [headers, setHeaders] = useState([]);
  const [chatInfo, setChatInfo] = useState([]);
  const outputOptions = [
    { value: "string", label: "String" },
    { value: "list", label: "List" },
  ];
  const [testApiResponse, setTestApiResponse] = useState(null);
  const [validated, setValidated] = useState(false);
  const [tested, setTested] = useState(false);
  const [refreshTable, setRefreshTable] = useState(false);

  const [testAPI] = useTestAPIMutation();
  const [saveAPI] = useSaveAPIsMutation();

  const [selectErrors, setSelectErrors] = useState({});

  const RequiredLabel = ({ label }) => (
    <Form.Label>
      {label}
      <span className="text-danger"> * </span>
    </Form.Label>
  );

  const addParameter = () => {
    if (parameterType === null) {
      setParameterType("FORM_DATA");
    }
    setParameters((prev) => [...prev, { key: "", value: "" }]);
  };

  const parameterChange = (event) => {
    setParameterType(event.target.value);
  };

  const updateParameter = (name, value, ind) => {
    setParameters((prev) =>
      prev.map((item, index) =>
        index === ind ? { ...item, [name]: value } : item
      )
    );
  };

  const deleteParams = (ind) => {
    setParameters((params) => params.filter((_, index) => index !== ind));
  };

  const addHeaders = () => {
    setHeaders((prev) => [...prev, { key: "", value: "" }]);
  };

  const updateHeader = (name, value, ind) => {
    setHeaders((prev) =>
      prev.map((item, index) =>
        index === ind ? { ...item, [name]: value } : item
      )
    );
  };

  const deleteHeaders = (ind) => {
    setHeaders((head) => head.filter((_, index) => index !== ind));
  };

  const addChatBotInfo = () => {
    setChatInfo((prev) => [
      ...prev,
      { responseContent: "", chatbotVariable: "", outputType: "" },
    ]);
  };

  const updateChatInfo = (name, value, ind, nested = false) => {
    setChatInfo((prev) =>
      prev.map((item, index) => {
        if (index !== ind) return item;

        // if updating nested listData
        if (nested) {
          return {
            ...item,
            listData: {
              ...item.listData,
              [name]: value,
            },
          };
        }

        // normal update (msg, user, etc.)
        return { ...item, [name]: value };
      })
    );
  };

  const deleteChatInfo = (ind) => {
    setChatInfo((item) => item.filter((_, index) => index !== ind));
  };

  const testApiCall = (e) => {
    e.preventDefault();
    e.stopPropagation();

    const form = e.currentTarget;

    // Validating react-select separately
    const isMethodValid = !!apiMethod;
    const isApiUrlValid =
      apiUrl !== "" &&
      /^https?:\/\/([a-zA-Z0-9.-]+)(:\d+)?(\/[^\s]*)?$/.test(apiUrl);
    let isObjectValid = true;
    if (parameterType === "JSON" && objectParameters) {
      if (typeof objectParameters !== "string" || !objectParameters.trim())
        return false;

      try {
        const parsed = JSON.parse(objectParameters);
        if (
          parsed === null &&
          typeof parsed !== "object" &&
          Array.isArray(parsed)
        )
          isObjectValid = false;
        else isObjectValid = true;
      } catch {
        isObjectValid = false;
      }
    }

    const isFormValid = form.checkValidity();

    if (isMethodValid && isApiUrlValid && isObjectValid && isFormValid) {
      const payload = {
        api_type: apiMethod?.value,
        api_url: apiUrl,
        parameter_type: parameterType,
        parameter_details:
          parameterType === "JSON" ? objectParameters : parameters,
        header_details: headers,
        chatbot_details: chatInfo,
      };

      testAPI(payload)
        .then((success) => {
          if (success?.data?.statusCode === 200) {
            setToastMessage(success?.data?.message);
            setToastVariant("success");
            setTestApiResponse(success?.data?.data);
            setTested(true);
          } else if (success?.data?.statusCode > 300) {
            setToastMessage(success?.data?.message || "Test failed!");
            setToastVariant("danger");
          }
          setShowToast(true);
        })
        .catch((error) => {
          setToastMessage(error.message || "Test failed!");
          setToastVariant("danger");
          setShowToast(true);
        });
    } else {
      setSelectErrors({
        method: !isMethodValid,
        url: !isApiUrlValid,
        object: !isObjectValid,
      });
    }
    setValidated(true);
  };

  const handleSave = () => {
    setToastMessage("");
    setToastVariant("");

    const payload = {
      api_name: apiName,
      api_type: apiMethod?.value,
      api_url: apiUrl,
      parameter_type: parameterType,
      parameter_details:
        parameterType === "JSON" ? objectParameters : parameters,
      header_details: headers,
      chatbot_details: chatInfo,
      response_status: testApiResponse?.statusCode,
    };

    saveAPI(payload)
      .then((success) => {
        if (success?.data?.statusCode === 200) {
          setToastMessage(success?.data?.message);
          setToastVariant("success");
          refreshFields();
          setRefreshTable(!refreshTable);
          setTested(true);
        } else if (success?.data?.statusCode > 300) {
          setToastMessage(success?.data?.message || "Failed to Save!");
          setToastVariant("danger");
        }
        setShowToast(true);
      })
      .catch((error) => {
        setToastMessage(error.message || "Server error!");
        setToastVariant("danger");
        setShowToast(true);
      });
  };

  const refreshFields = () => {
    setApiName("");
    setApiMethod(null);
    setApiUrl("");
    setParameters([]);
    setObjectParameters("");
    setHeaders([]);
    setChatInfo([]);
    setTestApiResponse(null);

    setSelectErrors({
      method: false,
      url: false,
      object: false,
    });
    setValidated(false);
  };

  const handleEdit = (props) => {
    setApiName(props.api_name)
    setApiMethod({ value: props.api_type, label: props.api_type });
    setApiUrl(props.api_url);
    setParameterType(props.parameter_type || null);
    (parameterType!==null && parameterType === "JSON") ? setObjectParameters(props.parameter_details || '') : setParameters(props.parameter_details || [])
    setHeaders(props.header_details||[])
    setChatInfo(props.chatbot_details || [])
    // response_status: testApiResponse?.statusCode,

    window.scrollTo({
      top: 0,
      behavior: "smooth",
    });
  }

  return (
    <>
      <ToastContainer position="top-end" className="p-3">
        <Toast
          bg={toastVariant}
          show={showToast}
          onClose={() => setShowToast(false)}
          delay={3000}
          autohide
        >
          <Toast.Header>
            <strong className="me-auto">Notification</strong>
          </Toast.Header>
          <Toast.Body>{toastMessage}</Toast.Body>
        </Toast>
      </ToastContainer>

      <Card border={1} className="mb-3">
        <Row>
          <Col md={12} lg={6}>
            <h5 className="mb-4">Configure API</h5>
            <Form
              noValidate
              validated={validated}
              autoComplete="off"
              onSubmit={handleSave}
            >
              <input
                type="text"
                name="preventAutoFill"
                style={{ display: "none" }}
              />
              <Row>
                <Col md={6} lg={12} className="mb-3">
                  <Form.Group id="api-name">
                    <RequiredLabel label="API Name" />
                    <Form.Control
                      required
                      type="text"
                      placeholder="Enter API Name"
                      value={apiName}
                      className="mb-0"
                      pattern="^[a-zA-Z0-9 ]+$"
                      onChange={(e) => {
                        const val = e.target.value;
                        if (val === "" || /^[a-zA-Z0-9 ]+$/.test(val)) {
                          setApiName(val);
                        }
                      }}
                      title="API Name must be alphanumeric."
                      autoComplete="new-instances"
                      isValid={validated && apiName}
                    />
                    <Form.Control.Feedback type="invalid">
                      Enter a valid API Name.
                    </Form.Control.Feedback>
                  </Form.Group>
                </Col>

                <Col lg={12} className="mb-3">
                  <Form.Group id="method">
                    <RequiredLabel label="API URL" />
                    <div className="d-flex align-items-top gap-2 w-100">
                      <div className="w-25">
                        <Select
                          options={methodOptions}
                          placeholder="Select"
                          className="mb-0"
                          isSearchable={true}
                          value={apiMethod}
                          onChange={(selectedOption) => {
                            setApiMethod(selectedOption);
                            setSelectErrors((prev) => ({
                              ...prev,
                              method: false,
                            }));
                          }}
                          styles={{
                            control: (provided, state) => ({
                              ...provided,
                              borderColor:
                                validated && !apiMethod
                                  ? "#dc3545"
                                  : validated && apiMethod
                                  ? "#65BB82"
                                  : provided.borderColor,
                              borderRadius: "0.75rem",
                            }),
                          }}
                        />
                      </div>
                      <Form.Control
                        required
                        type="text"
                        placeholder="Enter API URL"
                        value={apiUrl} // ✅ Controlled value
                        // pattern="^[a-zA-Z0-9]{0,8}$"
                        onChange={(e) => {
                          const val = e.target.value;
                          setApiUrl(val);
                          if (
                            val === "" ||
                            /^https?:\/\/[^\s/$.?#].[^\s]*$/.test(val)
                          ) {
                            setSelectErrors((prev) => ({
                              ...prev,
                              url: false,
                            }));
                          }
                        }}
                        title="API URL must be valid URL."
                        autoComplete="new-url"
                        isValid={validated && !selectErrors.url}
                      />
                    </div>

                    {(selectErrors.method || selectErrors.url) && (
                      <div className="invalid-feedback d-block">
                        Enter a valid API URL.
                      </div>
                    )}
                  </Form.Group>
                </Col>

                <Col lg={12} className="mb-3">
                  <Form.Group id="parameter">
                    <div className="d-flex align-items-center">
                      <Form.Label className="mb-0">Parameter Type</Form.Label>

                      {parameterType !== "JSON" && (
                        <Button
                          bsPrefix="text"
                          style={{
                            border: "none",
                            background: "none",
                            padding: 0,
                            color: "inherit",
                          }}
                          className="d-flex align-items-center text-info fw-bold ms-auto"
                          onClick={addParameter}
                        >
                          <IoMdAddCircle className="icon icon-xs me-2" />
                          <span>Add</span>
                        </Button>
                      )}
                    </div>

                    {parameterType !== null && (
                      <div className="d-flex flex-wrap justify-content-start">
                        <Form.Check
                          type="radio"
                          id="form"
                          label="Form Data"
                          value="FORM_DATA"
                          className="me-3"
                          onChange={parameterChange}
                          checked={parameterType === "FORM_DATA"}
                        />
                        <Form.Check
                          type="radio"
                          id="json"
                          label="JSON"
                          value="JSON"
                          className="me-3"
                          onChange={parameterChange}
                          checked={parameterType === "JSON"}
                        />
                        <Form.Check
                          type="radio"
                          id="queryString"
                          label="Query String"
                          value="QUERY_PARAMS"
                          className="me-3"
                          onChange={parameterChange}
                          checked={parameterType === "QUERY_PARAMS"}
                        />
                      </div>
                    )}
                    {parameterType !== "JSON" &&
                      parameters.length > 0 &&
                      parameters.map((param, index) => (
                        <div
                          className="d-flex align-items-center gap-2 mb-2"
                          key={index}
                        >
                          <Form.Control
                            required
                            type="text"
                            placeholder="Enter Parameter Key"
                            value={param.key}
                            pattern="^[a-zA-Z_][a-zA-Z0-9_\-]*$"
                            onChange={(e) => {
                              const val = e.target.value;
                              if (
                                val === "" ||
                                /^[a-zA-Z_][a-zA-Z0-9_-]*$/.test(val)
                              ) {
                                updateParameter("key", val, index);
                              }
                            }}
                            title="Parameter Key must start with a letter/underscore and contain only letters, numbers, underscores, or dashes."
                          />
                          <Form.Control
                            required
                            type="text"
                            placeholder="Enter Parameter Value"
                            value={param.value}
                            pattern="^[a-zA-Z0-9 ]+$"
                            onChange={(e) => {
                              const val = e.target.value;
                              //   if (val === "" || /^[a-zA-Z0-9 ]+$/.test(val)) {
                              updateParameter("value", val, index);
                              //   }
                            }}
                            title="Parameter Value must be alphanumeric."
                          />
                          <OverlayTrigger
                            placement="top"
                            overlay={<Tooltip className="m-0">Remove</Tooltip>}
                          >
                            <Card.Link
                              className="hover-text-danger"
                              onClick={() => deleteParams(index)}
                            >
                              <XCircleIcon className="icon icon-xs" />
                            </Card.Link>
                          </OverlayTrigger>
                        </div>
                      ))}
                    {parameterType === "JSON" && (
                      <>
                        <Form.Control
                          required
                          type="text"
                          as="textarea"
                          placeholder="Enter JSON"
                          value={objectParameters}
                          onChange={(e) => {
                            const val = e.target.value;
                            setObjectParameters(val);
                          }}
                          isInvalid={selectErrors.object}
                          title="JSON object must be valid"
                        />
                        {validated && selectErrors.object && (
                          <div className="invalid-feedback d-block">
                            Enter a valid JSON.
                          </div>
                        )}
                      </>
                    )}
                  </Form.Group>
                </Col>

                <Col sm={12} lg={12} className="mb-3">
                  <Form.Group id="header">
                    <div className="d-flex align-items-center">
                      <Form.Label>Header Details</Form.Label>

                      <Button
                        bsPrefix="text"
                        style={{
                          border: "none",
                          background: "none",
                          padding: 0,
                          color: "inherit",
                        }}
                        className="d-flex align-items-center text-info fw-bold ms-auto"
                        onClick={addHeaders}
                      >
                        <IoMdAddCircle className="icon icon-xs me-2" />
                        <span>Add</span>
                      </Button>
                    </div>
                    {headers.length > 0 &&
                      headers.map((header, index) => (
                        <div
                          className="d-flex align-items-center gap-2 mb-2"
                          key={index}
                        >
                          <Form.Control
                            required
                            type="text"
                            placeholder="Enter Header Key"
                            value={header.key}
                            pattern="^[A-Za-z0-9!#$%&'*+.^_`|~-]+$"
                            onChange={(e) => {
                              const val = e.target.value;
                              if (
                                val === "" ||
                                /^[A-Za-z0-9!#$%&'*+.^_`|~-]+$/.test(val)
                              ) {
                                updateHeader("key", val, index);
                              }
                            }}
                            title="Header Key must be alphanumeric and may include - and special characters (!#$%&'*+.^_`|~)."
                          />

                          <Form.Control
                            required
                            type="text"
                            placeholder="Enter Header Value"
                            value={header.value}
                            // pattern="^[a-zA-Z0-9]+$"
                            onChange={(e) => {
                              const val = e.target.value;
                              //   if (val === "" || /^[a-zA-Z0-9]+$/.test(val)) {
                              updateHeader("value", val, index);
                              //   }
                            }}
                            title="Header Value must be alphanumeric."
                          />
                          <OverlayTrigger
                            placement="top"
                            overlay={<Tooltip className="m-0">Remove</Tooltip>}
                          >
                            <Card.Link
                              className="hover-text-danger"
                              onClick={() => deleteHeaders(index)}
                            >
                              <XCircleIcon className="icon icon-xs" />
                            </Card.Link>
                          </OverlayTrigger>
                        </div>
                      ))}
                    {/* <Form.Control.Feedback type="invalid">
                      Enter a valid SMSC ID.
                    </Form.Control.Feedback> */}
                  </Form.Group>
                </Col>

                <Col sm={12} lg={12} className="mb-3">
                  <Form.Group id="config">
                    <div className="d-flex align-items-center">
                      <Form.Label>Chatbot Configurations</Form.Label>

                      <Button
                        bsPrefix="text"
                        style={{
                          border: "none",
                          background: "none",
                          padding: 0,
                          color: "inherit",
                        }}
                        className="d-flex align-items-center text-info fw-bold ms-auto"
                        onClick={addChatBotInfo}
                      >
                        <IoMdAddCircle className="icon icon-xs me-2" />
                        <span>Add</span>
                      </Button>
                    </div>

                    {chatInfo.length > 0 &&
                      chatInfo.map((item, index) => (
                        <div
                          className="d-flex flex-wrap align-items-center gap-2 mb-4 w-100"
                          key={index}
                        >
                          <div className="w-100 d-flex align-items-top gap-2">
                            <Form.Control
                              required
                              type="text"
                              placeholder="Enter response content to be used."
                              value={item.responseContent}
                              onChange={(e) => {
                                const val = e.target.value;
                                // if (val === "" || /^[a-zA-Z0-9 ]+$/.test(val)) {
                                updateChatInfo("responseContent", val, index);
                                // }
                              }}
                              title="Response Content must be alphanumeric."
                              className="w-50"
                            />
                            <Form.Control
                              required
                              type="text"
                              placeholder="Enter chatbot variable name."
                              value={item.chatbotVariable}
                              onChange={(e) => {
                                const val = e.target.value;
                                if (val === "" || /^[a-zA-Z0-9 ]+$/.test(val)) {
                                  updateChatInfo("chatbotVariable", val, index);
                                }
                              }}
                              title="Chatbot variable must be alphanumeric."
                              className="w-50"
                            />
                          </div>
                          <div style={{ width: "250px" }}>
                            <Select
                              options={outputOptions}
                              placeholder="Select Output Type"
                              className="mb-0"
                              isSearchable={true}
                              value={outputOptions.find((item)=>item.value===item.outputType || '')}
                              onChange={(selectedOption) => {
                                if (selectedOption.value === "list") {
                                  let updated = chatInfo.map((item, ind) =>
                                    ind === index
                                      ? {
                                          ...item,
                                          outputType: "list",
                                          listData: { key: "", value: "" },
                                        }
                                      : item
                                  );
                                  setChatInfo(updated);
                                } else {
                                  updateChatInfo(
                                    "outputType",
                                    selectedOption.value,
                                    index
                                  );
                                }
                              }}
                              styles={{
                                control: (provided, state) => ({
                                  ...provided,
                                  borderColor:
                                    validated && !item.outputType
                                      ? "#dc3545"
                                      : validated && item.outputType
                                      ? "#65BB82"
                                      : provided.borderColor,
                                  borderRadius: "0.75rem",
                                }),
                              }}
                            />
                          </div>
                          <OverlayTrigger
                            placement="top"
                            overlay={<Tooltip className="m-0">Remove</Tooltip>}
                          >
                            <Card.Link
                              className="hover-text-danger ms-auto"
                              onClick={() => deleteChatInfo(index)}
                            >
                              <XCircleIcon className="icon icon-xs" />
                            </Card.Link>
                          </OverlayTrigger>
                          {item.outputType === "list" && (
                            <div className="d-flex align-items-center gap-2">
                              <Form.Control
                                required
                                type="text"
                                placeholder="Enter Primary Field Name."
                                value={item.listData.key}
                                onChange={(e) => {
                                  const val = e.target.value;
                                  updateChatInfo("key", val, index, true);
                                }}
                                title="Primary Field Name must be alphanumeric."
                                className="w-50"
                              />
                              <Form.Control
                                required
                                type="text"
                                placeholder="Enter Display Field Name."
                                value={item.listData.value}
                                onChange={(e) => {
                                  const val = e.target.value;
                                    updateChatInfo("value", val, index, true);
                                }}
                                title="Display Field Name must be alphanumeric."
                                className="w-50"
                              />
                            </div>
                          )}
                        </div>
                      ))}
                  </Form.Group>
                </Col>
              </Row>

              <div className="mt-3 d-flex align-items-center justify-content-end gap-2">
                <Button
                  variant="secondary"
                  className="animate-up-2"
                  type="button"
                  onClick={testApiCall}
                >
                  Test
                </Button>
                {tested && (
                  <Button
                    variant="secondary"
                    className="animate-up-2"
                    type="submit"
                  >
                    Save
                  </Button>
                )}
              </div>
            </Form>
          </Col>

          <Col md={12} lg={6}>
            <h6 className="my-3">API Response</h6>

            <Form.Group id="api-resp" className="mb-3">
              <Form.Label>Response Status</Form.Label>
              <Form.Control
                type="text"
                placeholder="test API to see response"
                disabled
                value={testApiResponse ? testApiResponse?.statusCode : ""}
                className="mb-0"
              />
            </Form.Group>

            <Form.Group id="resp-cont" className="mb-3">
              <Form.Label>Response Content</Form.Label>
              <Form.Control
                type="text"
                as="textarea"
                placeholder="test API to see response"
                rows={10}
                disabled
                value={
                  testApiResponse
                    ? JSON.stringify(testApiResponse, null, 2)
                    : ""
                }
                className="mb-0"
              />
            </Form.Group>
          </Col>
        </Row>
      </Card>
      <ChatFlowApiTables key={refreshTable} handleEditAPI={handleEdit} />
    </>
  );
};
